function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 22,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.602051 1.88582C1.30205 1.46582 2.04205 1.16582 2.82205 0.98582C3.60205 0.80582 4.35205 0.71582 5.07205 0.71582C6.33205 0.71582 7.43205 0.925819 8.37205 1.34582C9.33205 1.74582 10.0721 2.32582 10.5921 3.08582C11.1321 3.82582 11.4021 4.68582 11.4021 5.66582C11.4021 6.54582 11.2321 7.32582 10.8921 8.00582C10.5521 8.68582 10.1121 9.30582 9.57205 9.86582C9.05205 10.4258 8.52205 10.9758 7.98205 11.5158C7.44205 12.0558 6.97205 12.6158 6.57205 13.1958C6.17205 13.7758 5.93205 14.4358 5.85205 15.1758L5.70205 16.0158H3.51205V14.7858C3.51205 13.8658 3.64205 13.0658 3.90205 12.3858C4.18205 11.7058 4.52205 11.1058 4.92205 10.5858C5.32205 10.0658 5.72205 9.57582 6.12205 9.11582C6.54205 8.63582 6.88205 8.15582 7.14205 7.67582C7.42205 7.17582 7.56205 6.61582 7.56205 5.99582C7.56205 5.29582 7.32205 4.75582 6.84205 4.37582C6.36205 3.99582 5.68205 3.80582 4.80205 3.80582C4.16205 3.80582 3.48205 3.90582 2.76205 4.10582C2.04205 4.30582 1.32205 4.62582 0.602051 5.06582V1.88582ZM2.52205 22.3158V18.1158H6.75205V22.3158H2.52205Z",
  fill: "#FAA300"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 22,
  fill: "white"
})));

var SvgIcNodelivery = function SvgIcNodelivery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcNodelivery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_nodelivery.142cfbaf.svg";
export { ForwardRef as ReactComponent };